import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ACTIVETAB } from './RightSideComponents';

const routeToTab: Record<string, ACTIVETAB> = {
  [ROUTES.MAP.SHAPES.$path()]: ACTIVETAB.SHAPES,
  [ROUTES.MAP.FILTERS.$path()]: ACTIVETAB.FILTERS,
  [ROUTES.MAP.REPORTS.$path()]: ACTIVETAB.REPORTS,
  [ROUTES.MAP.EVENTS.$path()]: ACTIVETAB.EVENTS,
  [ROUTES.MAP.REPLAY.$path()]: ACTIVETAB.REPLAY,
  [ROUTES.MAP.ATONS.$path()]: ACTIVETAB.ATONS,
  [ROUTES.MAP.MESSAGES.$path()]: ACTIVETAB.MESSAGES,
  [ROUTES.MAP.PORTADMIN.$path()]: ACTIVETAB.PORTADMIN,
};

const tabToRoute: Record<string, string> = Object.fromEntries(
  Object.entries(routeToTab).map(([route, tab]) => [tab, route]),
);

/**
 * Derives the active map tab from the URL pathname (single source of truth).
 * No bidirectional sync needed — activeTab is always consistent with the URL.
 */
export const useMapTabRouteSync = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = routeToTab[location.pathname] ?? ACTIVETAB.NONE;

  const navigateToTab = useCallback(
    (tab: ACTIVETAB) => {
      const route =
        tab === ACTIVETAB.NONE
          ? ROUTES.MAP.$path()
          : (tabToRoute[tab] ?? ROUTES.MAP.$path());
      navigate(route, { replace: true });
    },
    [navigate],
  );

  return { activeTab, navigateToTab };
};
